module.exports = __webpack_public_path__ + "img/slide5-m.3fe25f09.png";